import BlogsModel from '../Apis/Blogs'
import Controller from './Controller'

export default class BlogsController extends Controller {
  constructor() {
    super(new BlogsModel())
  }
}
